import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/UploadPage.css";

const ChooseUploadMode = ({ authKey }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!authKey) {
      navigate("/", { replace: true });
    }
  }, [authKey]);

  const goTo = (path) => {
    navigate(path, { state: { authKey } });
  };

  return (
    <div className="upload-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div className="upload-card">
        <h2 className="upload-title">📤 Wybierz tryb przesyłania</h2>

        <p style={{ marginBottom: "2rem", fontSize: "1rem", color: "#666" }}>
          Wybierz, w jaki sposób chcesz przesłać plik.
        </p>

        <button
          className="upload-button"
          style={{ marginBottom: "1rem" }}
          onClick={() => goTo("/upload-uid")}
        >
        Tryb 1 – Upload z UID tagiem
        </button>

        <button
          className="upload-button"
          style={{ marginBottom: "1rem" }}
          onClick={() => goTo("/upload-pinkpet")}
        >
        Tryb 2 – Upload PinkPet
        </button>

        <button
          className="upload-button"
          onClick={() => goTo("/upload-old")}
        >
        Tryb 3 – Klasyczny upload
        </button>
      </div>
    </div>
  );
};

export default ChooseUploadMode;
